<template>
  <div class="needsValidation page-container">
    <div class="page-title">
      {{ $t('menu.batch_payment_details') }}
    </div>
    <div class="filter-container">
      <div class="custom-breadcrumbs">
        <i class="el-icon-arrow-left icon-back" @click="onClickBackBtn" />
        <span @click="onClickBackBtn">{{ $t('customerService.payment_details') }}</span>
      </div>
    </div>
    <div class="tableContainer">
      <!-- 列表 -->
      <el-table
        v-loading="listLoading"
        :data="tableData"
        stripe
        fit
        highlight-current-row
        style="width: 100%"
        class="tableContainer"
      >
        <el-table-column :label="$t('customerService.transaction_id')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.transaction_id }}</span>
          </template>
        </el-table-column>

        <el-table-column v-if="['TH', 'RU'].includes($store.getters.curCountry.country_code)" min-width="100" :label="$t('merchantAccount.beneficiary_account_type')" align="center">
          <template slot-scope="scope">
            <span>{{ beneficiaryAccountTypeFormat(scope.row.beneficiary_account_type) }}</span>
          </template>
        </el-table-column>

        <el-table-column v-if="['TH', 'RU'].includes($store.getters.curCountry.country_code)" :label="$t('merchantAccount.beneficiary_type')" align="center">
          <template slot-scope="scope">
            <span>{{ beneficiaryTypeFormat(scope.row.beneficiary_type) }}</span>
          </template>
        </el-table-column>

        <el-table-column v-if="$store.getters.curCountry.country_code === 'RU'" :label="$t('merchantAccount.beneficiary_category')" align="center">
          <template slot-scope="scope">
            <span>{{ beneficiaryCategoryFormat(scope.row.beneficiary_category) }}</span>
          </template>
        </el-table-column>

        <el-table-column v-if="$store.getters.isPii" :label="$t('components.transaction_country')" align="center">
          <template slot-scope="scope">
            <span>{{ $store.getters.findOnlineCountryObj(scope.row.country_code).label }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.beneficiary_name')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.account_name | cryptoJSAesDecrypt }}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="110" :label="$t('merchantAccount.receiving_channel')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.code }}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="110" :label="$t('merchantAccount.beneficiary_account_no')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.account_no | cryptoJSAesDecrypt }}</span>
          </template>
        </el-table-column>

        <!--受益人地址-->
        <el-table-column v-if="$store.getters.curCountry.country_code === 'AE'" min-width="140" :label="$t('map.benefit_address')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.beneficiary_address }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('components.amount')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.amount | toThousandFilter }}</span>
          </template>
        </el-table-column>

        <!-- <el-table-column label="Service Fee" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.service_fee }}</span>
          </template>
        </el-table-column> -->

        <!-- <el-table-column
          :label="$t('customerService.validation')"
          align="center"
          min-width="100"
        >
          <template slot-scope="scope">

            <el-tooltip v-if="scope.row.unvalidated_fields && scope.row.unvalidated_fields.length >0" placement="top">
              <div slot="content">
                <span>{{ scope.row.unvalidated_fields.join(',') }}</span>
              </div>
              <el-tag type="danger" class="tag-custom">{{ scope.row.unvalidated_fields.join(',') }}</el-tag>
            </el-tooltip>

            <el-tag v-else type="success" class="tag-custom">Passed</el-tag>

          </template>
        </el-table-column> -->

        <!-- <el-table-column label="Email" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.email }}</span>
          </template>
        </el-table-column> -->

        <el-table-column :label="$t('merchantAccount.transaction_status')" align="center">
          <template slot-scope="scope">
            <el-tag class="tag-custom" :type="getPOTransactionStatusType(scope.row.transaction_status)"> {{ getPOTransactionStatusMap(scope.row.transaction_status) }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.create_time')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.transaction_create_time }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.complete_time')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.transaction_return_time }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('components.operation')" align="center">
          <template slot-scope="scope">

            <el-tooltip v-if="scope.row.transaction_id" placement="top">
              <div slot="content">
                <span> {{ $t('components.detail') }}</span>
              </div>
              <svg-icon class-name="icon-function" icon-class="operation-detail" @click="onClickDetailTxt(scope.row)" />
            </el-tooltip>

          </template>
        </el-table-column>

      </el-table>
      <div class="pagination-container">
        <paginator v-if="!listLoading" :list-query="listQuery" @paginator-change="onClickPaginator" />
      </div>
      <StandardValuePaymentStepDetailsModal ref="standardValuePaymentStepDetailsModal" />
    </div>
  </div>
</template>

<script>

import { fetchDisbursementRefernceDetail } from '@/api/online-transaction/online-transaction'
import { poTransStatusMap } from '@/utils/maps'
export default {
  name: 'Detail_Disbursement',
  components: {
    StandardValuePaymentStepDetailsModal: () => import('./components/Modal/LargeValuePaymentStepDetailsModal.vue'),
    Paginator: () => import('@/views/components/Paginator')
  },
  data() {
    return {
      detailId: '0',
      status: null,
      tableData: [],
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 15,
        total: 0
      },
      downloading: false
    }
  },
  computed: {
    beneficiaryAccountTypeFormat() {
      const obj = {
        'BANK': this.$t('map.beneficiary_account_type_0'),
        'PROMPTPAY': this.$t('map.beneficiary_account_type_1'),
        'SBP': this.$t('map.beneficiary_account_type_3'),
        'EWALLET': this.$t('map.beneficiary_account_type_2')
      }
      return function(value) {
        if (value) {
          return obj[value]
        }
        return value
      }
    },
    beneficiaryTypeFormat() {
      const obj = {
        'NATIONAL_ID': this.$t('map.beneficiary_type_0'),
        'MOBILE_NUMBER': this.$t('map.beneficiary_type_1'),
        'BANK_ACCOUNT': this.$t('map.beneficiary_type_2'),
        'CARD_NUMBER': this.$t('map.beneficiary_type_3'),
        'EWALLET_ID': this.$t('merchantAccount.account_type_ewallet_id')
      }
      return function(value) {
        if (value) {
          return obj[value]
        }
        return value
      }
    },
    beneficiaryCategoryFormat() {
      const obj = {
        'INDIVIDUAL': this.$t('merchantAccount.beneficiary_category_individual'),
        'ORGANIZATION': this.$t('merchantAccount.beneficiary_category_organization')
      }
      return function(value) {
        return obj[value] || value
      }
    },
    getPOTransactionStatusType() {
      return function(value) {
        return poTransStatusMap(value).type
      }
    },
    getPOTransactionStatusMap() {
      return function(value) {
        return poTransStatusMap(value).label
      }
    }
  },
  created() {
    const { status } = this.$route.params
    this.status = Number(status)
    this.getDisbursementRefernceDetail()
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    getDisbursementRefernceDetail(otherParams) {
      this.listLoading = true
      const params = this.getParams(otherParams)
      fetchDisbursementRefernceDetail(params).then(res => {
        if (res.code === 10000) {
          const { total, list = [] } = res.data
          this.listQuery.total = total
          this.listQuery.page = params.page ? params.page : 1
          this.tableData = list
        }
      }).finally(() => {
        this.listLoading = false
      })
    },

    getParams(otherParams = {}) {
      const { id } = this.$route.params
      const params = {
        ...otherParams,
        batch_no: id
      }
      return params
    },

    onClickPaginator() {
      this.getDisbursementRefernceDetail(this.listQuery)
    },
    onClickBackBtn() {
      this.$router.push({ name: 'Batch_Payout_Reference', query: this.$route.query })
    },

    onClickDetailTxt(row) {
      if (row.transaction_status) {
        this.detailId = row.transaction_id
        this.showPayDetailModal(row)
      }
    },
    showPayDetailModal(row) {
      this.$refs.standardValuePaymentStepDetailsModal.showModal({ disbursement_transaction_id: row.transaction_id, remark: row.remark })
    }
  }
}
</script>

<style lang="scss" scoped>
.needsValidation{
   .transTime{
    display: inline-block;
    padding: 0 20px 10px 0;
    font-size: 14px;
    font-weight: 500;  font-family: 'Inter-Medium';
    color: #606266;
  }

  .btn-container{
    display: flex;
    justify-content: flex-end;
  }
  .search-frame {
    width: 160px;
    margin-right: 5px;
  }
  .search-btn {
    margin-right: 10px;
  }
  .picker{
    margin-right: 5px;
  }
  .status{
    margin-right: 10px;
  }
  .download-btn{
    margin: 0;
  }
 .mb-10{
    margin-bottom: 10px;
  }
  .disabled{
    cursor: no-drop;
  }
}

</style>
